<template>
    <div class="inMiddle-area table-responsive horizontalScroll">
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader && pageName != 'dashboard'"></complete-loading>
        <!--<div class="d-flex justify-content-between border-bottom pb-3 px-3 mb-2" v-if="pageName != 'dashboard'">
            <div></div>
            <filter-component :limitFilter="'disable'" :searchFilter="'disable'" :pageTitle="'close-trade'"></filter-component>
        </div>-->
        <table class="table customize opencloseTrade-table" v-if="lastSelectTradingAccount != '' && (lastSelectTradingAccount[0].platform == 'MT4' || lastSelectTradingAccount[0].platform == 'ZULU')">
            <thead>
                <tr class="position-relative">
                    <th v-if="row_MT4.includes(1)">{{$t('closetrad_login')}}</th>
                    <th v-if="row_MT4.includes(2)">{{$t('closetrad_order')}}</th>
                    <th v-if="row_MT4.includes(3)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_MT4.includes(4)">{{$t('closetrad_volume')}}</th>
                    <th v-if="row_MT4.includes(5)">{{$t('closetrad_openPrice')}}</th>
                    <th v-if="row_MT4.includes(6)">{{$t('closetrad_openTime')}}</th>
                    <th v-if="row_MT4.includes(7)">{{$t('closetrad_commision')}}</th>
                    <th v-if="row_MT4.includes(8)">{{$t('closetrad_type')}}</th>
                    <th v-if="row_MT4.includes(9)">{{$t('closetrad_SL')}}</th>
                    <th v-if="row_MT4.includes(10)">{{$t('closetrad_TP')}}</th>
                    <th v-if="row_MT4.includes(11)">{{$t('closetrad_closePrice')}}</th>
                    <th v-if="row_MT4.includes(12)">{{$t('closetrad_closeTime')}}</th>
                    <th v-if="row_MT4.includes(13)">{{$t('closetrad_Swap')}}</th>
                    <th v-if="row_MT4.includes(14)">{{$t('closetrad_PNL')}}</th>
                    <th v-if="row_MT4.includes(15)">{{$t('closetrad_comment')}}</th>
                    <th width="60" class="ExtraTableData">
                            <span class="tableoption dotAreaForButton" @click.prevent="mt4Check = !mt4Check"><feather type="more-vertical" size="1rem"></feather></span>
                            <div class="tablefilter box-shadow ListTabArea" v-if="mt4Check">
                                 <ul>
                                    <li v-for="data,index in mt4List">
                                        <input v-model="row_MT4" :value="index+1" type="checkbox" :id="data+'_mt4'"  class="login_mt5">
                                        <label :for="data+'_mt4'" >{{data}} </label>
                                    </li>
                                 </ul>
                            </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'history' in accountDetails && Object.keys(accountDetails.history).length >0 && accountDetails.history.csv_array.length > 0">
                <tr v-for="list in accountDetails.history.csv_array" >
                    <td v-if="row_MT4.includes(1)">{{list[0]}} </td>
                    <td v-if="row_MT4.includes(2)">{{list[1]}} </td>
                    <td v-if="row_MT4.includes(3)">{{decodeURIComponent(list[2])}}</td>
                    <td v-if="row_MT4.includes(4)">{{list[6]/100}}</td>
                    <td v-if="row_MT4.includes(5)">{{list[3]}}</td>
                    <td v-if="row_MT4.includes(6)">{{timeFunc(list[7])}}</td>
                    <td v-if="row_MT4.includes(7)">{{list[10]}}</td>
                    <td v-if="row_MT4.includes(8)">
                        <p  v-if="list[12] == 0">{{$t('buy')}}</p>
                        <p  v-else-if="list[12] == 1">{{$t('sell')}}</p>
                        <p  v-else-if="list[12] == 6">{{$t('deposit')}}</p>
                    </td>
                    <td v-if="row_MT4.includes(9)" >{{list[13]}}</td>
                    <td v-if="row_MT4.includes(10)">{{list[14]}}</td>
                    <td v-if="row_MT4.includes(11)">{{list[4]}}</td>
                    <td v-if="row_MT4.includes(12)">
                        <p v-if="list[12] !== 6">{{timeFunc(list[8])}}</p>
                        <p v-else> -  </p>
                    </td>
                    <td v-if="row_MT4.includes(13)">{{list[15]}}</td>
                    <td v-if="row_MT4.includes(14)">{{list[5]}}</td>
                    <td v-if="row_MT4.includes(15)">{{decodeURIComponent(list[9])}}</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="10"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>

        <table class="table customize opencloseTrade-table" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT5'">
            <thead>
                <tr class="position-relative">

                    <th v-if="row_MT5.includes(1)">{{$t('closetrad_login')}}</th>
                    <th v-if="row_MT5.includes(2)">{{$t('deal')}}</th>
                    <th v-if="row_MT5.includes(3)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_MT5.includes(4)">{{$t('closetrad_type')}}</th>
                    <th v-if="row_MT5.includes(5)">{{$t('closetrad_volume')}}</th>
                    <th v-if="row_MT5.includes(6)">{{$t('closetrad_openTime')}}</th>
                    <th v-if="row_MT5.includes(7)">{{$t('closetrad_price')}}</th>
                    <th v-if="row_MT5.includes(8)">{{$t('closetrad_commision')}}</th>
                    <th v-if="row_MT5.includes(9)">{{$t('closetrad_Swap')}}</th>
                    <th v-if="row_MT5.includes(10)">{{$t('closetrad_PNL')}}</th>
                    <th v-if="row_MT5.includes(11)">{{$t('closetrad_comment')}}</th>
                    <th width="60" class="ExtraTableData">
                        <span class="tableoption dotAreaForButton" @click.prevent="mt5Check = !mt5Check"><feather type="more-vertical" size="1rem"></feather></span>
                        <div class="tablefilter box-shadow ListTabArea" v-if="mt5Check">
                             <ul>
                                <li v-for="data,index in mt5List">
                                    <input v-model="row_MT5" :value="index+1" type="checkbox" :id="data+'_mt5'"  class="login_mt5">
                                    <label :for="data+'_mt5'" >{{data}} </label>
                                </li>
                             </ul>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'history' in accountDetails && Object.keys(accountDetails.history).length >0 && accountDetails.history.csv_array.length > 0">
                <tr v-for="list in accountDetails.history.csv_array">
                    <td v-if="row_MT5.includes(1)">{{list[0]}} </td>
                    <td v-if="row_MT5.includes(2)">{{list[1]}}</td>
                    <td v-if="row_MT5.includes(3)">{{decodeURIComponent(list[3])}}</td>
                    <td v-if="row_MT5.includes(4)">
                        <p  v-if="list[13] == 0">{{$t('buy')}}</p>
                        <p  v-else-if="list[13] == 1">{{$t('sell')}}</p>
                        <p  v-else-if="list[13] == 2">{{$t('deposit')}}</p>
                    </td>
                    <td v-if="row_MT5.includes(5)">{{list[9]}}</td>
                    <td v-if="row_MT5.includes(6) && list[13] !== 2">{{timeFunc(list[12])}}</td>
                    <td v-else-if="row_MT5.includes(6)">-</td>
                    <td v-if="row_MT5.includes(7)">{{list[4]}}</td>
                    <td v-if="row_MT5.includes(8)">{{list[6]}}</td>
                    <td v-if="row_MT5.includes(9)">{{list[24]}}</td>
                    <td v-if="row_MT5.includes(10)">{{list[5]}}</td>
                    <td v-if="row_MT5.includes(11)">{{decodeURIComponent(list[25])}}</td>
                    
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="10"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>
        <table class="table customize opencloseTrade-table" v-else-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT'">
            <thead>
                <tr  class="position-relative">
                    <th v-if="row_ACT.includes(1)">{{$t('closetrad_login')}}</th>
                    <th v-if="row_ACT.includes(2)">{{$t('closetrad_order')}}</th>
                    <th v-if="row_ACT.includes(3)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_ACT.includes(4)">{{$t('closetrad_volume')}}</th>
                    <th v-if="row_ACT.includes(5)">{{$t('closetrad_openPrice')}}</th>
                    <th v-if="row_ACT.includes(6)">{{$t('closetrad_openTime')}}</th>
                    <th v-if="row_ACT.includes(7)">{{$t('closetrad_closePrice')}}</th>
                    <th v-if="row_ACT.includes(8)">{{$t('closetrad_closeTime')}}</th>
                    <th v-if="row_ACT.includes(9)">{{$t('closetrad_PNL')}}</th>
                    <th v-if="row_ACT.includes(10)">{{$t('closetrad_comment')}}</th>
                    <th width="60" class="ExtraTableData">
                        <span class="tableoption dotAreaForButton" @click.prevent="actCheck = !actCheck"><feather type="more-vertical" size="1rem"></feather></span>
                        <div class="tablefilter box-shadow ListTabArea" v-if="actCheck">
                             <ul>
                                <li v-for="data,index in actList">
                                    <input v-model="row_ACT" :value="index+1" type="checkbox" :id="data+'_act'" class="login_mt5">
                                    <label :for="data+'_act'" >{{data}}</label>
                                </li>
                             </ul>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'history' in accountDetails && accountDetails.history.length >0">
                <tr v-for="list in accountDetails.history">
                    <td v-if="row_ACT.includes(1)">{{list.TRADER}}</td>
                    <td v-if="row_ACT.includes(2)">{{list.TRADER_ID}}</td>
                    <td v-if="row_ACT.includes(3)">{{list.INSTRUMENT_NAME}}</td>
                    <td v-if="row_ACT.includes(4)">{{list.CLOSE_AMOUNT}}</td>
                    <td v-if="row_ACT.includes(5)">{{list.OPEN_RATE}}</td>
                    <td v-if="row_ACT.includes(6)">{{timeFunc(parseInt(list.OPEN_TIME/1000))}}</td>
                    <td v-if="row_ACT.includes(7)">{{list.CLOSE_RATE}}</td>
                    <td v-if="row_ACT.includes(8)">{{timeFunc(parseInt(list.CLOSE_TIME/1000))}}</td>
                    <td v-if="row_ACT.includes(9)">{{list.NET_PNL}}</td>
                    <td v-if="row_ACT.includes(10)">-</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="10"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        props:['pageName'],
        data() {
            return {
            	col_span : 7 ,
            	col_span1 : 13,
            	fromDateField : '',
            	toDateField : '',
            	pageLoader : false,

            	row_ACT : [1,2,3,4],
            	actCheck: false,
                actList:['login','order','symbol','volume','openPrice','openTime','closePrice','closeTime','PNL','comment'],
                
                row_MT4 : [1,2,3,4],
                mt4List:['login','order','symbol','volume','openPrice','openTime','commision','type','SL','TP','Price','Time','Swap','PNL','comment'],
                mt4Check: false,

                row_MT5 : [1,2,3,4],
                mt5List : ['login','deal','symbol','type','Volume','openTime','price','commission','swap','pnl','comment'],
                mt5Check: false,
        	}
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        'from':this.fromDateField.toString() ,
                        'to':this.toDateField.toString(),
                        'act_account_id': this.lastSelectTradingAccount[0].act_account_id,
                        'account_id' : this.lastSelectTradingAccount[0].account_id,  
                        'demo_live' : this.lastSelectTradingAccount[0].demo_live , 
                        'platform' : this.lastSelectTradingAccount[0].platform
                    } ,'localParams' : {'parameter' : this }
                }
                this._runGetAccountHistory(inputJson)
            },
            timeFunc(getData){
                return moment.unix(getData).format("DD-MM-YYYY, h:mm:ss");
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/close_trades_listing.vue